import { useEffect, useReducer, useState } from 'react';

import { purgeLegacyOidcState } from '@xemplo/auth-core';

import { initialAuthState, reducer } from '../auth-provider.reducer';
import { AuthProviderProps } from '../auth-provider.types';
import { createUserManager } from '../create-user-manager';

import { useUserManagerEvents } from './use-manager-events';
import { useSigninCallback } from './use-signin-callback';
import { useUserManager } from './use-user-manager';

const useAuthState = (props: Omit<AuthProviderProps, 'children'>) => {
  const { onSigninCallback, onRemoveUser, ...config } = props;
  const [userManager] = useState(() => createUserManager(config));
  const [state, dispatch] = useReducer(reducer, initialAuthState);

  // State now lives in sessionStorage, so the library's own `clearStaleState()`
  // no longer sees the localStorage backlog earlier builds left behind.
  useEffect(() => {
    purgeLegacyOidcState();
  }, []);

  const api = useUserManager(userManager, dispatch, state, onRemoveUser);
  useSigninCallback({ userManager, dispatch, onSigninCallback });
  useUserManagerEvents(userManager, dispatch);

  return { ...state, ...api };
};

export default useAuthState;
